import {
  CognitoUserPool,
  CognitoUserAttribute
} from "amazon-cognito-identity-js";
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useInputChange } from '../../helpers/useInputChange'
import { useInputChangeWithoutTrim } from '../../helpers/useInputChangeWithoutTrim'
import { useTranslation } from 'react-i18next';
const moment = require('moment-timezone');

const userPool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
  ClientId: process.env.REACT_APP_COGNITO_CLIENTID,
});

const SignUpPage = () => {

  const [email, setEmail] = useInputChange()
  const [givenName, setGivenName] = useInputChangeWithoutTrim()
  const [familyName, setFamilyName] = useInputChangeWithoutTrim()
  const [password, setPassword] = useInputChange()
  const [error, setError] = useState()
  const [marketingEmails, setMarketingEmails] = useState(true)
  const history = useHistory()
  const { t } = useTranslation()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const redirect = urlParams.get('redirect')
    if (redirect) {
      sessionStorage.setItem("redirect", redirect)
    } 
  })

  const onSubmit = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true
    const trimEmail = email.trim();
    const trimPassword = password.trim();
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: trimEmail
      }),
      new CognitoUserAttribute({
        Name: 'given_name',
        Value: givenName.trim()
      }),
      new CognitoUserAttribute({
        Name: 'family_name',
        Value: familyName.trim()
      }),
      new CognitoUserAttribute({
        Name: 'custom:marketing_email',
        Value: marketingEmails ? "true" : "false"
      }),
      new CognitoUserAttribute({
        Name: 'zoneinfo',
        Value: moment.tz.guess()
      })
    ];
    userPool.signUp(trimEmail, trimPassword, attributeList, null, (err, result) => {
      button.clicked = false
      if (err) {
        setError(err.message)
        return;
      } else {
        sessionStorage.setItem("signup_email", trimEmail)
        history.push("/user/confirmation")
      }
    });
  }

  document.title = t("titleappname") + t("title_page_signup")

  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_signup")}</h3>

      <h5>{t("desc_signup")}</h5>

      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="form-control"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_email")}
          onChange={setEmail}
          required={true} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>

      
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_password")}</span><br />

        <input className="form-control"
          type="password"
          name="password"
          autoComplete="new-password"
          id="password"
          placeholder={t("tip_password")}
          onChange={setPassword} 
          required={true} 
          minlength="6"
          pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,99}" 
          title={t("val_password")} />
        <span className="focus-input100" data-symbol="&#xf023;"></span>

      </div>

      <div className="d-flex">
        <div className="wrap-input45 validate-input">
          <span className="label-input100">{t("lbl_name")}</span><br />
          <input className="form-control"
            type="text"
            name="given-name"
            autoComplete="given-name"
            id="given-name"
            placeholder={t("tip_given_name")}
            value={givenName}
            onChange={setGivenName} required={true} />
          <span className="focus-input100" data-symbol="&#xf007;"></span>
        </div>
        <div style={{ width: "10%" }}>&nbsp;</div>
        <div className="wrap-input45 validate-input">
          <br />
          <input className="form-control"
            type="text"
            name="family-name"
            autoComplete="family-name"
            id="family-name"
            placeholder={t("tip_family_name")}            
            value={familyName}
            onChange={setFamilyName} required={true} />
          <span className="focus-input100" data-symbol="&#xf0c0;"></span>
        </div>
      </div>

      <br/>
      
      <div className="custom-control custom-switch">
          <input type="checkbox" className="custom-control-input" id="marketing_email" onChange={(e) => setMarketingEmails(e.target.checked)} checked={marketingEmails} />
          <label className="custom-control-label" htmlFor="marketing_email">{t("lbl_marketing_email")}</label>
      </div>

      <br/>
      
      <small id="errorMessage" className="text">{t("account_terms")}</small><br />
      {error ? <small id="errorMessage" className="text-danger">{error}<br /></small> : ""}

      <br />
      <div>
        <button className="submit-btn">
          {t("btn_signup")}
        </button>
      </div>
      <br />
      <div >
        <a href="/user/login">{t("btn_login")}</a>
      </div>
    </form>
  </div>

}

export default SignUpPage
